import { sizes } from '../../const/sizes';
import cogs from './assets/cogs.riv';
import stopwatch from './assets/stopwatch.riv';
export const animationMap = { stopwatch, cogs };
export const animationSizeMap = {
    small: sizes.animation.small,
    medium: sizes.animation.medium,
};
